import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
    getUserWithdrawalIndex(state,value){
        
        
       
        post(urls.admin.withdrawal.index,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
    editUserWithdrawal(state,value){
        
        
       
        post(urls.admin.withdrawal.edit,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
 

    
  
    
   
   
    

}
const  actions={

    
    getUserWithdrawalIndexAction(context,value){
       
        context.commit("getUserWithdrawalIndex",value)
       
    },
    editUserWithdrawalAction(context,value){
       
        context.commit("editUserWithdrawal",value)
       
    },
  
   
    
   
    
    

}

export default {state,mutations,actions}